import React from "react";
import { classNames } from "Utils/utils";

const PaFilterChip = ({ active, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={classNames(
      "rounded-full px-3 py-1 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
      active
        ? "bg-indigo-600 text-white"
        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
    )}
  >
    {children}
  </button>
);

export default PaFilterChip;
